import axios from 'axios';
import store from '../../../store';
import { FORM_NAME_ENUMS } from '@/shared-modules/variables/form-name.enums';
import { smallNotification } from '@/shared-modules/services/gf.notification.service';
import qs from 'qs';

export default {
  getExistingCiCdVariables(alias, projectAlias) {
    return axios.get(`/api/project/${alias}/${projectAlias}/setting/edit-cicd-variable`).then((res) => {
      store.dispatch('setExistingCiCdVariables',
        {
          formName: FORM_NAME_ENUMS.PROJECT_SETTINGS_EDIT_CI_CD_FORM,
          variables: res.data
        }
      )
      return res.data;
    });
  },

  editCiCdVariables(alias, projectAlias, data) {
    return axios
      .post(
        `/api/project/${alias}/${projectAlias}/setting/edit-project-cicd-variables`,
        qs.parse(data),
        {
          formName: FORM_NAME_ENUMS.PROJECT_SETTINGS_EDIT_CI_CD_FORM
        }
      )
      .then((res) => {
        store.dispatch('setExistingCiCdVariables',
          {
            formName: FORM_NAME_ENUMS.PROJECT_SETTINGS_EDIT_CI_CD_FORM,
            variables: res.data.existingVariables
          }
        )
        smallNotification('success', { title: 'Переменные сохранены!' });
        this.getExistingCiCdVariables(alias, projectAlias);
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка!' });
        throw err;
    });
  },


  testWebhookUrl(userAlias, projectAlias, params) {
    return axios
      .post(`/api/project/${userAlias}/${projectAlias}/webhook/test`, null, {
        params, 
        formName: FORM_NAME_ENUMS.PROJECT_SETTING_WEBHOOK_FORM_URL
      })
      .then((res) => {
        if (res.data?.responseCode != 404) {
          smallNotification('success', { title: 'Успешно' })
        } else {
          smallNotification('danger', { title: 'Произошла ошибка!' })
        }
        return res
      }).catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка!' })
        throw err
      })
  }
};